exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ":host,:host h2{display:flex;font-family:Open Sans}:host h2{justify-content:center;font-size:2.2rem;font-weight:600;margin:4rem auto}:host .btn-error{height:8rem;font-size:1.5rem}:host .btn-error:last-child i{margin-right:.2rem}:host .icon{font-size:4rem;margin:4rem auto 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["./~/bootstrap/scss/_functions.scss","./~/bootstrap/scss/_variables.scss","./src/main/webapp/content/scss/variables.scss"]}!./src/main/webapp/app/layouts/error/error.component.scss
// module id = 698
// module chunks = 0